import axios from "axios";
import store from "../store/index";

const apiFrontstageClient = axios.create({
  // baseURL: "https://stage.kingdom9999.tw/api/api"
  baseURL: process.env.VUE_APP_API_URL,
});

const authBackstageClient = axios.create({
  // baseURL: "https://stage.kingdom9999.tw/api/api"
  baseURL: process.env.VUE_APP_API_URL,
});

apiFrontstageClient.interceptors.request.use(function (config) {
  config.headers["Authorization"] = `Bearer ${store.getters.getToken}`;
  return config;
});

authBackstageClient.interceptors.request.use(function (config) {
  config.headers["Authorization"] = `Bearer ${store.getters.getBackstageToken}`;
  return config;
});

const responseHandler = {
  200: (res) => res.data,
  400: (res) => Promise.reject(res),
  401: (res) => Promise.reject(res),
  404: (res) => Promise.reject(res),
  405: (res) => Promise.reject(res),
  500: () => Promise.reject("伺服器錯誤"),
};

export default {
  async frontGET(path, data = "") {
    let query = new URLSearchParams(data).toString();
    query = query.length ? "?" + query : query;
    const response = await apiFrontstageClient
      .get(path + query)
      .catch((e) => e.response);
    return responseHandler[response.status](response);
  },
  async frontPOST(path, data) {
    const response = await apiFrontstageClient
      .post(path, data)
      .catch((e) => e.response);
    return responseHandler[response.status](response);
  },
  async frontPUT(path, data) {
    const response = await apiFrontstageClient
      .put(path, data)
      .catch((e) => e.response);
    return responseHandler[response.status](response);
  },
  async frontDELETE(path) {
    const response = await apiFrontstageClient
      .delete(path)
      .catch((e) => e.response);
    return responseHandler[response.status](response);
  },
  async backGET(path, data = "") {
    let query = new URLSearchParams(data).toString();
    query = query.length ? "?" + query : query;
    const response = await authBackstageClient
      .get(path + query)
      .catch((e) => e.response);
    return responseHandler[response.status](response);
  },
  async backPOST(path, data) {
    const response = await authBackstageClient
      .post(path, data)
      .catch((e) => e.response);
    return responseHandler[response.status](response);
  },
  async backPUT(path, data) {
    const response = await authBackstageClient
      .put(path, data)
      .catch((e) => e.response);
    return responseHandler[response.status](response);
  },
  async backDELETE(path) {
    const response = await authBackstageClient
      .delete(path)
      .catch((e) => e.response);
    return responseHandler[response.status](response);
  },
  async backPATCH(path) {
    const response = await authBackstageClient
      .patch(path)
      .catch((e) => e.response);
    return responseHandler[response.status](response);
  },
};
